export default {
    en: {
        CHALLENGE_SETTINGS_IS_DEFAULT_CHALLENGE: 'Default challenge',
        CHALLENGE_SETTINGS_MAX_NUMBER_OF_ATTEMPTS: 'Max number of attempts'
    }
};
